module.exports = __webpack_public_path__ + "img/default.af737a13.png";